import React, { useEffect, useState } from "react";

import obyektdizayn from "../../assets/img/obyektdizayn.png";
import budahazr from "../../assets/img/budahazr.png";
import idealOlan from "../../assets/img/ideal olan.png";
import ffQadirNewSlider from "../../assets/img/FFQadirnewslider.png";

const slides = [
  {
    id: 1,
    image: obyektdizayn,
    alt: "FFQADİR.AZ",
  },
  {
    id: 2,
    image: budahazr,
    alt: "FFQADİR.AZ",
  },
  {
    id: 3,
    image: idealOlan,
    alt: "FFQADİR.AZ",
  },
  {
    id: 4,
    image: ffQadirNewSlider,
    alt: "FFQADİR.AZ",
  },
];

const AUTO_PLAY_TIME = 7000;

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  /* AUTO PLAY */
  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, AUTO_PLAY_TIME);

    return () => clearInterval(interval);
  }, [isHovered]);

  /* KEYBOARD */
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        setCurrentSlide((prev) =>
          prev === 0 ? slides.length - 1 : prev - 1
        );
      }

      if (event.key === "ArrowRight") {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  /* PREVIOUS */
  const previousSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  /* NEXT */
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section
      id="carousel_games"
      className="
        relative
        w-full
        overflow-hidden
        bg-white
        dark:bg-slate-950
        select-none
      "
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* =====================================================
          SLIDER WRAPPER (hündürlük şəklin özünə görə, kəsilmir)
      ====================================================== */}
      <div className="relative grid w-full overflow-hidden">
        {/* SLIDES */}
        {slides.map((slide, index) => {
          const isActive = index === currentSlide;

          return (
            <div
              key={slide.id}
              className={`
                col-start-1
                row-start-1
                flex
                items-center
                justify-center
                w-full
                transition-opacity
                duration-700
                ease-in-out
                ${
                  isActive
                    ? "opacity-100 z-10"
                    : "opacity-0 z-0 pointer-events-none"
                }
              `}
            >
              <img
                src={slide.image}
                alt={slide.alt}
                draggable="false"
                className="block w-full h-auto"
              />
            </div>
          );
        })}

        {/* =====================================================
            LEFT ARROW (Mobil üçün kiçildilmiş)
        ====================================================== */}
        <button
          type="button"
          onClick={previousSlide}
          aria-label="Əvvəlki slayd"
          className="
            absolute
            left-1.5
            sm:left-4
            top-1/2
            -translate-y-1/2
            z-30
            flex
            items-center
            justify-center
            w-7
            h-7
            sm:w-9
            sm:h-9
            md:w-10
            md:h-10
            rounded-full
            border
            border-white/30
            dark:border-white/20
            bg-black/40
            hover:bg-black/70
            backdrop-blur-sm
            text-white
            transition-all
            duration-200
            hover:scale-105
            active:scale-95
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 sm:w-5 sm:h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {/* =====================================================
            RIGHT ARROW (Mobil üçün kiçildilmiş)
        ====================================================== */}
        <button
          type="button"
          onClick={nextSlide}
          aria-label="Növbəti slayd"
          className="
            absolute
            right-1.5
            sm:right-4
            top-1/2
            -translate-y-1/2
            z-30
            flex
            items-center
            justify-center
            w-7
            h-7
            sm:w-9
            sm:h-9
            md:w-10
            md:h-10
            rounded-full
            border
            border-white/30
            dark:border-white/20
            bg-black/40
            hover:bg-black/70
            backdrop-blur-sm
            text-white
            transition-all
            duration-200
            hover:scale-105
            active:scale-95
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 sm:w-5 sm:h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* =====================================================
            DOTS (Şəklin tam daxilində alt tərəfdə)
        ====================================================== */}
        <div
          className="
            absolute
            bottom-2
            sm:bottom-3
            left-1/2
            -translate-x-1/2
            z-30
            flex
            items-center
            gap-1.5
            px-2
            py-1
            rounded-full
            bg-black/30
            backdrop-blur-sm
          "
        >
          {slides.map((slide, index) => {
            const isActive = index === currentSlide;

            return (
              <button
                key={slide.id}
                type="button"
                onClick={() => setCurrentSlide(index)}
                aria-label={`${index + 1}-ci slayda keç`}
                className={`
                  h-1.5
                  rounded-full
                  transition-all
                  duration-300
                  ${
                    isActive
                      ? "w-6 sm:w-8 bg-white"
                      : "w-1.5 bg-white/50 hover:bg-white/80"
                  }
                `}
              />
            );
          })}
        </div>

        {/* =====================================================
            COUNTER (Şəklin daxilində sağ küncdə)
        ====================================================== */}
        <div
          className="
            absolute
            right-2
            sm:right-4
            bottom-2
            sm:bottom-3
            z-30
            hidden
            sm:flex
            items-center
            gap-1
            px-2
            py-0.5
            rounded-full
            border
            border-white/20
            bg-black/40
            backdrop-blur-sm
            text-white
            text-[10px]
            sm:text-xs
            font-medium
          "
        >
          <span>{String(currentSlide + 1).padStart(2, "0")}</span>
          <span className="opacity-40">/</span>
          <span className="opacity-70">
            {String(slides.length).padStart(2, "0")}
          </span>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;